import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageHeader from "../PageHeader";
import heroBackImage from "../images/hero/hero.webp";
import "../css/blogs.css";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const resolveImageUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  if (src.startsWith("/uploads/")) return `${API_BASE_URL}${src}`;
  return src;
};

const BlogsPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const breadcrumbLinks = [
    { label: "الرئيسية", path: "/" },
    { label: "المدونة", path: "/blogs" },
  ];

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/blogs`);
        if (!res.ok) {
          setLoading(false);
          return;
        }
        const data = await res.json();
        setBlogs(Array.isArray(data.blogs) ? data.blogs : []);
      } catch {
        setBlogs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <>
      <PageHeader title="المدونة" bgImage={heroBackImage} breadcrumbs={breadcrumbLinks} />

      <section className="blogs-section">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <div className="section-title">
                <h2>مقالات نبض كير</h2>
                <p>
                  محتوى إرشادي يساعدك على فهم المتطلبات وتسريع الإجراءات المتعلقة بهيئة الغذاء والدواء،
                  وزارة الصناعة، التخليص الجمركي، وإصدار الشهادات.
                </p>
              </div>
            </div>
          </div>

          <div className="row blogs-grid">
            {loading && <p>جاري تحميل المقالات...</p>}
            {!loading &&
              blogs.map((blog) => (
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={blog.id}>
                  <Link to={`/blogs/${blog.slug}`} className="blog-card">
                    <div
                      className="blog-card-bg"
                      style={{ backgroundImage: `url(${resolveImageUrl(blog.image)})` }}
                    />
                    <div className="blog-card-overlay" />
                    <div className="blog-card-content">
                      <div className="blog-badges">
                        <span className="blog-badge">{blog.category}</span>
                        <span className="blog-badge">{blog.readTime}</span>
                      </div>
                      <h3>{blog.title}</h3>
                      <p>{blog.excerpt}</p>
                    </div>
                  </Link>
                </div>
              ))}
            {!loading && blogs.length === 0 && (
              <p className="text-center">لا توجد مقالات متاحة حالياً.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogsPage;

